import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import dayjs from "dayjs";
import useApi from "../../core/customhook/useApi";

function decimalHoursToHHMM(decimalHours: number): string {
  const hours = Math.floor(decimalHours);

  // Truncate minutes to match 2-decimal truncation
  const minutes = Math.round((decimalHours - hours) * 60);


  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

const TimeSheetLogEmployees = () => {
  const { id } = useParams()
  const [callApi, setCallApi] = useState(1)
  const [task, setTask] = useState<any>([])
  const [viewLog, setViewLog] = useState<any>(null);

  const {
    data: timelog,
    loading: timelogLoading,
    error: timelogError,
  } = useApi(`/api/get-employee-time-logs`, {
    method: "POST",
    payload: {
      task_id: id
    },
    autoCall: true,
    dependencies: [id, callApi]
  });


  useEffect(() => {
    if (timelog?.success) {
      setTask(timelog?.data)
    }
  }, [timelog])


  const columns = [
    {
      title: "Employee",
      dataIndex: "",
      render: (text: string, record: any) => (
        <h6 className="fw-medium">
          {`${record.employee_name}-${record.employee_id}`}
        </h6>
      ),
      sorter: (a: any, b: any) => a.project_name.localeCompare(b.project_name),
    },
    // {
    //   title: "Project Name",
    //   dataIndex: "ProjectName",
    //   render: (text: string, record: any) => (
    //     <h6 className="fw-medium">
    //       {record.project_name}
    //     </h6>
    //   ),
    //   sorter: (a: any, b: any) => a.project_name.localeCompare(b.project_name),
    // },
    {
      title: "Task",
      dataIndex: "task_name",
      render: (text: string, record: any) => (
        <h6 className="fw-medium">
          {record.task_name}
        </h6>
      ),
      sorter: (a: any, b: any) => a.task_name.localeCompare(b.task_name),
    },
    {
      title: "StartDate",
      dataIndex: "start_date",
      sorter: (a: any, b: any) => a.start_date.localeCompare(b.start_date),
      render: (value: string) =>
        value ? dayjs(value).format("D MMMM YYYY") : "-",
    },
    {
      title: "EndDate",
      dataIndex: "end_date",
      sorter: (a: any, b: any) => a.end_date.localeCompare(b.end_date),
      render: (value: string) =>
        value ? dayjs(value).format("D MMMM YYYY") : "-",
    },
    {
      title: "Complete",
      dataIndex: "complete",
      render: (value: number) => (
        <span>{value}%</span>
      ),
      sorter: (a: any, b: any) => a.complete - b.complete,
    },
    {
      title: "Log Date",
      dataIndex: "log_date",
      sorter: (a: any, b: any) => a.log_date.localeCompare(b.log_date),
      render: (value: string) =>
        value ? dayjs(value).format("D MMMM YYYY") : "-",
    },
    {
      title: "Log Hours",
      dataIndex: "log_hours",
      sorter: (a: any, b: any) => parseFloat(a.log_hours) - parseFloat(b.log_hours),
      render: (text: any) => `${text} hrs`,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: string, record: any) => {
        return (
          <div className="action-icon d-inline-flex">
            <Link
              to="#"
              className="text-success"
              title="View"
              data-bs-toggle="modal"
              data-bs-target="#view_log_modal"
              onClick={() => setViewLog(record)}
            >
              <i className="ti ti-eye" style={{ cursor: "pointer" }} />
            </Link>
          </div>
        );
      },
    }
  ];


  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">TimeLog</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Employee</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      TimeLog
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="mb-2 me-2">
                  <Link
                    to="/tasks"
                    className="btn btn-outline-secondary d-flex align-items-center"
                  >
                    <i className="ti ti-arrow-narrow-left me-2" />
                    Back
                  </Link>
                </div>
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            {/* Project list */}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>TimeLog List</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  {/* <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Select Status
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Active
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Inactive
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Sort By : Last 7 Days
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Desending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
              <div className="card-body p-0">
                <Table dataSource={task} columns={columns} Selection={false} showSearchInput={true} />
              </div>
            </div>
            {/* / Project list  */}
          </div>
          <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
            <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>


      {/* Boostrap View Modal   */}
      <div
        className="modal fade"
        id="view_log_modal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                View Time Log – {dayjs(viewLog?.log_date).format("DD MMMM YYYY")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Enter Hours</label>
                <input
                  type="time"
                  className="form-control"
                  value={decimalHoursToHHMM(viewLog?.log_hours)} // convert decimal to HH:MM
                  readOnly
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Existing Documents</label>

                {viewLog?.documents && viewLog.documents.length > 0 ? (
                  <ul className="list-group">
                    {viewLog.documents.map((file: any, index: number) => (
                      <li
                        key={index}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <span>Document {index + 1}</span>

                        <a
                          href={file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-primary"
                        >
                          View
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-muted">No document uploaded</p>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  value={viewLog?.notes}
                  readOnly
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary mx-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Boostrap View Modal   */}

    </>
  );
};

export default TimeSheetLogEmployees;

// <div className="modal fade" id="view_log_modal" role="dialog">
//   <div className="modal-dialog modal-dialog-centered modal-lg">
//     <div className="modal-content">
//       <div className="modal-header header-border align-items-center justify-content-between">
//         <h5 className="modal-title">Time Log Details</h5>
//         <button
//           type="button"
//           className="btn-close custom-btn-close"
//           data-bs-dismiss="modal"
//           aria-label="Close"
//         >
//           <i className="ti ti-x" />
//         </button>
//       </div>

//       <div className="modal-body">
//         {viewLog ? (
//           <div className="row g-3">
//             {/* Project & Task (Optional) */}
//             {viewLog.project_name && (
//               <div className="col-md-6">
//                 <div className="bg-light border rounded p-3 h-100">
//                   <h6 className="mb-1 text-muted">Project</h6>
//                   <p className="mb-0 fw-semibold">{viewLog.project_name}</p>
//                 </div>
//               </div>
//             )}
//             {viewLog.task_name && (
//               <div className="col-md-6">
//                 <div className="bg-light border rounded p-3 h-100">
//                   <h6 className="mb-1 text-muted">Task</h6>
//                   <p className="mb-0 fw-semibold">{viewLog.task_name}</p>
//                 </div>
//               </div>
//             )}

//             {/* Log Date */}
//             <div className="col-md-6">
//               <div className="bg-light border rounded p-3 h-100">
//                 <h6 className="mb-1 text-muted">Log Date</h6>
//                 <p className="mb-0 fw-semibold">
//                   {dayjs(viewLog.log_date).format("DD-MM-YYYY")}
//                 </p>
//               </div>
//             </div>

//             {/* Log Hours */}
//             <div className="col-md-6">
//               <div className="bg-light border rounded p-3 h-100">
//                 <h6 className="mb-1 text-muted">Log Hours</h6>
//                 <p className="mb-0 fw-semibold">{viewLog.log_hours} hrs</p>
//               </div>
//             </div>

//             {/* Other Logs */}
//             {viewLog.other_logs && (
//               <div className="col-12">
//                 <div className="bg-light border rounded p-3">
//                   <h6 className="mb-1 text-muted">Other Log Entries</h6>
//                   <p className="mb-0 fw-semibold">{viewLog.other_logs}</p>
//                 </div>
//               </div>
//             )}

//             {/* Notes */}
//             {viewLog.notes && (
//               <div className="col-12">
//                 <div className="bg-light border rounded p-3">
//                   <h6 className="mb-1 text-muted">Notes</h6>
//                   <div
//                     className="mb-0 fw-semibold"
//                     dangerouslySetInnerHTML={{ __html: viewLog.notes }}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>
//         ) : (
//           <p>Loading...</p>
//         )}
//       </div>
//     </div>
//   </div>
// </div>